export default "__VITE_ASSET__ea7XbzGO__"